import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {Store} from '@ngrx/store';

import {decodeOnHoldCode} from '../../../../shared/shared-module-ui/utils/on-hold-code/on-hold-code.utils';

@Component({
  selector: 'app-cell-renderer-supplier-search-code',
  templateUrl: './cell-renderer-supplier-search-code.component.html',
  styleUrls: ['./cell-renderer-supplier-search-code.component.scss'],
  standalone: false,
})
export class CellRendererSupplierSearchCodeComponent implements ICellRendererAngularComp {

  params: ICellRendererParams;
  width: string;
  value: boolean;
  type: string;
  departments: {} = {};
  protected readonly onHoldDecode = decodeOnHoldCode;

  constructor(
    private readonly store: Store,
  ) {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;
    this.type = params.colDef.field;
  }

  getOnHoldCodeArray(code: number): string {
    return decodeOnHoldCode(code, {returnCodes: false, isSupplier: true}).join(', ');
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
